import {
  get_AI_URI_BASE,
  get_AUTH_HOST,
  get_CDN_BASE_URL,
  get_CDN_ROOT_FOLDER,
  get_DASHBOARD_URI_BASE,
  get_IS_CDN77,
  getIsEdge,
} from "./configs/env";
import { SESSION_POLICY, decodeEdgeSessionClaims } from "@korra/session";
import axios from "axios";
import {
  Document,
  Library,
  Theme,
  GetFirstGuidResponse,
  StartSessionResponse,
  PingSessionResponse,
  IResponse,
  PortalItem,
  EdgeUser,
  StoredEdgeUser,
  Favorite,
} from "./models/interfaces";
import { route } from "preact-router";
import { store } from "./redux/store";
import {
  setExplanator,
  setBackgroundImage,
  setBackgroundSize,
  setLogoSrc,
  setLogoHref,
  setQuestionsForExample,
  setContactUsDestinationLink,
  setFileRepositoryDestinationLink,
  setEnableContactUsDestinationLink,
  setEnableFileRepositoryDestinationLink,
  setEnableQuestionsForExample,
  setSearchBarPlaceHolder,
  setDisableFilters,
  setIsPrivate,
  setHighlightPdf,
  setHideFileName,
  setShowManyHeaders,
  setMaxPerSubject,
  setLoaded,
  setIsRTL,
  setYearRangeEnabled,
  setYearRangeEnabled2,
  setTagMessageMap,
  setFilterSidebarTagsFirst,
  setBgPortraitImage,
  setShowRelatedDocuments,
  setFiltersType,
  setMediaTypeClientSideFiltering,
  setShowKeywordFilterFlag,
  setShowHomePageFilter,
  setDocumentWatermark,
  setCompactSearchArea,
  setActiveLogger,
  setEnableImageSearch,
  setExpandGptAnswer,
  setUseGptPolling,
  setShowFilePath,
  setContactUsDestinationMessage,
  setEnableKeywordToggle,
  setEnableFilters,
  setEnableFavorites,
  setEnableDiveDeeper,
  setEnableRecentlyViewed,
  setDisableRag,
} from "./redux/slices/appearanceSlice";
import {
  setChronologicalOrder,
  setIsChronological,
} from "./redux/slices/searchSlice";
import { setLoading } from "./redux/slices/chatbotSlice";
import { isEdge } from "react-device-detect";
import { redactSecrets } from "./logger";
import { clearUserSession } from "./api/token-refresh";
import { endEdgeSessionLocally } from "./api/edge-session";
import { queryClient, userSessions } from "./lib/queryClient";
interface IAlias {
  workspaceId?: string;
  portalId?: string;
  workspaceAlias: string;
  portalAlias: string;
}
export const isComputeAgentRoute = (): boolean =>
  typeof window !== "undefined" &&
  window.location.pathname.includes("generalAI");

export const withWsd = (detail: string, wsd: boolean): string => {
  if (!wsd || !detail) return detail;
  const url = new URL(detail, window.location.origin);
  url.searchParams.set("wsd", "true");
  return url.pathname + url.search + url.hash;
};

/**
 * general utils class
 */
export const Utils = {
  /**
   * initialize
   */
  init: () => {
    // put on window so that pdfjs and other external libs can use
    (window as any).printTimeAndDelta = Utils.printTimeAndDelta;
    (window as any)._timeStart = Date.now();
  },
  /**
   * print the time now and delta to previous print
   */
  printTimeAndDelta: () => {
    let timeNow = Date.now();
    // console.log(
    //   "%c Time now: " +
    //     timeNow +
    //     " delta: " +
    //     (timeNow - (window as any)._timeStart),
    //   "background: #222; color: #bada55"
    // );
    (window as any)._timeStart = timeNow;
  },
  //  `/workspace/${workspaceId}/portal/${portalId}/search?q=${input.current?.value}`
  ///workspace/${workspaceId}/kapp/${kappId}/search?q=${input.current?.value}`;
  //
  getRouteParams: (routeTo: string) => {
    let parts = routeTo?.split("/");
    if (routeTo.indexOf("portal/") >= 0) {
      return {
        portalId: parts[4],
        workspaceId: parts[2],
        q: routeTo.substring(routeTo.indexOf("search?q=") + "search?q=".length),
      };
    } else if (routeTo.indexOf("search?q=") >= 0) {
      return {
        kappId: parts[4],
        workspaceId: parts[2],
        q: routeTo.substring(routeTo.indexOf("search?q=") + "search?q=".length),
      };
    } else return null;
  },

  /**
   *
   * @param text
   * @param cb
   * @returns
   */
  typeText(text: string, cb: Function) {
    var i = 0;
    if (text == "") {
      return;
    }
    let texRet = "";
    let words = text.split(" ");
    var intervalId = setInterval(function () {
      texRet += words[i] + " "; // text.charAt(i);
      cb(texRet);
      i++;
      if (i >= words.length) {
        clearInterval(intervalId);
        cb("*** stop ***");
      }
    }, 50);
  },

  /**
   * Get the theme from the server.
   *
   * The two empty results are not the same thing, so they are not the same
   * value: `undefined` means the lookup succeeded and the portal has no such
   * theme, `null` means the lookup itself failed. Callers that clear portal
   * state on "no theme" must act on the former only -- treating a timed-out
   * request as "no theme" flips a live portal to the LTR defaults mid-session.
   */
  async getTheme(
    workspaceId: string,
    portalId: string,
    preview: boolean = false,
  ): Promise<Theme | undefined | null> {
    try {
      const response = await axios(
        `${get_DASHBOARD_URI_BASE()}/portals/${portalId}/workspaces/${workspaceId}`,
      );
      const portalInfo = response?.data?.data;
      const theme: Theme | undefined = portalInfo?.themes?.find(
        (theme: Theme) => theme.name === (preview ? "preview" : "publish"),
      );

      return theme;
    } catch (ex) {
      console.error(
        `Cant access ${get_DASHBOARD_URI_BASE()}/portals/${portalId}/workspaces/${workspaceId}`,
      );
    }

    return null;
  },

  getMuted() {
    let muted = Utils.localStorageGet("muted");
    if (muted == undefined) {
      muted = "true";
      Utils.localStorageSet("muted", "true");
    }
    return muted == "true";
  },

  setMuted(muted: boolean) {
    Utils.localStorageSet("muted", muted ? "true" : "false");
  },
  localStorageGet(key: string) {
    try {
      return localStorage.getItem(key);
    } catch (err) {
      console.error(err);
      return null;
    }
  },
  localStorageSet(key: string, value: string | null) {
    try {
      if (value == null) localStorage.removeItem(key);
      else localStorage.setItem(key, value || "");
    } catch (err) {
      console.error(err);
    }
  },

  uint8ToString(data: Uint8Array): string {
    var decoder = new TextDecoder();
    return decoder.decode(data);
  },

  stringToUint8(str: string): Uint8Array {
    var encoder = new TextEncoder();
    return encoder.encode(str);
  },

  /**
   * reset the profiling
   */
  resetTimeMeasurement: () => {
    (window as any)._timeStart = Date.now();
  },

  goHome: (alias: IAlias, kappId: string) => {
    const { workspaceAlias, portalAlias, workspaceId, portalId } = alias;
    let detail: string;
    if (workspaceAlias && portalAlias) {
      detail = `/${workspaceAlias}/${portalAlias}`;
    } else {
      detail =
        portalId && portalId?.length > 0
          ? `/workspace/${workspaceId}/portal/${portalId}/home`
          : `/workspace/${workspaceId}/kapp/${kappId}/home`;
    }

    (window as any).dispatchFnEvent(
      new CustomEvent("route-to", {
        detail,
      }),
    );
  },
  setCookie: (cookieName: string, cookieValue: string, expirationDays = 30) => {
    var expirationDate = new Date();
    expirationDate.setDate(expirationDate.getDate() + expirationDays);

    var cookieString =
      encodeURIComponent(cookieName) +
      "=" +
      encodeURIComponent(cookieValue) +
      ";expires=" +
      expirationDate.toUTCString() +
      ";path=/";

    document.cookie = cookieString;
  },

  getCookieValue: (cookieName: string): string => {
    var name = cookieName + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var cookieArray = decodedCookie.split(";");

    for (var i = 0; i < cookieArray.length; i++) {
      var cookie = cookieArray[i];
      while (cookie.charAt(0) === " ") {
        cookie = cookie.substring(1);
      }
      if (cookie.indexOf(name) === 0) {
        return cookie.substring(name.length, cookie.length);
      }
    }
    return "";
  },

  localLogout: () => {
    // Client-side route (no page unload) so pagehide won't fire — end the
    // session explicitly (issue #1733 Task 2). Must run before
    // clearUserSession(), which nulls the sessionId/userId it reads.
    endCurrentSession();
    clearUserSession();
    Utils.setCookie("idToken", "", -1);
    Utils.routeToLogin(null);
  },

  // Local edge logout, no server revoke: used when another tab has signed out
  // (useEdgeCrossTabLogout, #1733), so the session is already ended server-side.
  // Delegates to the edge session module so this tab also stops its session
  // manager and clears its tokens, ends the stats session (endCurrentSession,
  // first, as #1733 requires) and lands on the login page (#1100).
  edgeLogout: () => {
    endEdgeSessionLocally("manual");
  },

  secureGet: async (url: string, headers: any) => {
    return await axios.get(url, { headers });
  },

  /**
   *
   * @returns
   */
  getIdentifyingComponents: () => {
    // analyze the second part
    const getKappOrPortal: any = (parts: string[]) => {
      if (parts[2] == "kapp") {
        console.error("No kappId allowed when route to login");
        return { kappId: parts[3], portalId: null };
      } else if (parts[2] == "portal") {
        return { kappId: null, portalId: parts[3] };
      }
      console.error(
        "unknown url - no kapp or portal in the url path " +
          window.location.pathname,
      );
      return { kappId: null, portalId: null };
    };

    // cut the pathname into parts
    let parts = window.location.pathname.split("/");
    // remove the first empty part
    parts.shift();
    let kpObj: any;
    switch (parts[0]) {
      case "workspace":
        kpObj = getKappOrPortal(parts);
        return { workspaceId: parts[1], ...kpObj };
      case "company":
        kpObj = getKappOrPortal(parts);
        return { workspaceId: parts[1], ...kpObj };
      default:
        return {
          workspaceAlias: parts[0],
          portalAlias: parts[1],
          workspaceId: null,
          portalId: null,
          kappId: null,
        };
    }
  },

  /**
   *
   * @returns
   */
  buildPathname: () => {
    const { workspaceAlias, portalAlias, workspaceId, portalId, kappId } =
      Utils.getIdentifyingComponents();
    // build the pathname
    let pathname = "";
    if (workspaceId) pathname += `/workspace/${workspaceId}`;
    if (portalId) pathname += `/portal/${portalId}`;
    if (kappId) pathname += `/kapp/${kappId}`;
    if (workspaceAlias) pathname += `/${workspaceAlias}`;
    if (portalAlias) pathname += `/${portalAlias}`;
    return pathname;
  },
  /**
   * route to login with the current href
   */

  routeToLogin: (aliases: IAlias | null) => {
    let href = window.location.href;
    // encode href in base64
    href = btoa(href);
    href = encodeURIComponent(href);
    // if aliases, use them
    if (aliases) {
      route(
        "/" +
          aliases.workspaceAlias +
          "/" +
          aliases.portalAlias +
          "/login/redirect/" +
          href,
      );
    } else {
      // get the alias1/alias2 or workspace/id/portal/id from the url
      // if kappId, sends a error message but still route to login
      let pathname = Utils.buildPathname();
      route(pathname + "/login/redirect/" + href);
    }
  },

  checkUrlAnchor: (url: string): boolean => {
    return url.includes("#");
  },
};

// initialize
Utils.init();
const MAX_CHUNK_SIZE = 1024 * 10;

export const delay = async (ms: number) => {
  return new Promise((resolve) => setTimeout(resolve, ms));
};

class LRUCache {
  private maxEntries: number;
  private cache: { [key: string]: string };

  constructor(maxEntries: number) {
    this.maxEntries = maxEntries;
    this.cache = {};
    this.loadFromIndexedDB();
  }

  private loadFromIndexedDB(): void {
    const request = window.indexedDB.open("cacheDB", 1);

    request.onerror = () => {
      console.error("Error opening cache database.");
    };

    request.onsuccess = (event: Event) => {
      const db = (event.target as any).result;
      const transaction = db.transaction(["cache"], "readonly");
      const objectStore = transaction.objectStore("cache");

      objectStore.openCursor().onsuccess = (event: Event) => {
        const cursor = (event.target as any).result;
        if (cursor) {
          this.cache[cursor.key] = cursor.value;
          cursor.continue();
        }
      };
    };

    request.onupgradeneeded = (event: any) => {
      const db = event.target.result;
      if (!db.objectStoreNames.contains("cache")) {
        db.createObjectStore("cache");
      }
    };
  }

  get(key: string): Uint8Array | null {
    if (this.cache[key]) {
      this.moveToFront(key);
      return this.stringToAsciiByteArray(this.cache[key]);
      // return this.jsonToUint8Array(this.cache[key]);
    }
    return null;
  }

  put(key: string, value: Uint8Array): void {
    this.cache[key] = this.asciiByteArrayToString(value);
    // this.cache[key] = this.uint8ArrayToJson(value);
    // Check if cache has reached maximum capacity
    if (Object.keys(this.cache).length > this.maxEntries) {
      // Purge the least recently used item
      const oldestKey = Object.keys(this.cache)[0];
      delete this.cache[oldestKey];
    }

    this.saveToIndexedDB();
  }

  private saveToIndexedDB(): void {
    const request = window.indexedDB.open("cacheDB", 1);

    request.onerror = () => {
      console.error("Error opening cache database.");
    };

    request.onsuccess = (event: Event) => {
      const db = (event.target as any).result;
      const transaction = db.transaction(["cache"], "readwrite");
      const objectStore = transaction.objectStore("cache");

      objectStore.clear();

      for (const [key, value] of Object.entries(this.cache)) {
        objectStore.put(value, key);
      }
    };

    request.onupgradeneeded = (event: any) => {
      const db = event.target.result;
      if (!db.objectStoreNames.contains("cache")) {
        db.createObjectStore("cache");
      }
    };
  }

  private moveToFront(key: string): void {
    const value = this.cache[key];
    delete this.cache[key];
    this.cache[key] = value;
    this.saveToIndexedDB();
  }

  private uint8ArrayToJson(array: Uint8Array): string {
    const jsonArray = Array.from(array);
    return JSON.stringify(jsonArray);
  }

  private jsonToUint8Array(json: string): Uint8Array {
    const jsonArray = JSON.parse(json);
    return new Uint8Array(jsonArray);
  }

  private uint8ArrayToString(array: Uint8Array): string {
    const encoder = new TextDecoder("UTF-8");
    return encoder.decode(array).toString();
  }

  private stringToUint8Array(str: string): Uint8Array {
    const decoder = new TextEncoder();
    return decoder.encode(str);
  }

  // encode the string as ascii bytes
  private stringToAsciiByteArray(str: string): Uint8Array {
    const bytes = new Uint8Array(str.length);
    for (let i = 0; i < str.length; ++i) {
      bytes[i] = str.charCodeAt(i);
    }
    return bytes;
  }

  // decode the bytes as ascii string
  private asciiByteArrayToString(bytes: Uint8Array): string {
    let str = "";
    for (let i = 0; i < bytes.length; ++i) {
      str += String.fromCharCode(bytes[i]);
    }
    return str;
  }
}

// Usage
let pdfFileCache: any;
export const getPdfFileCache = () => {
  if (!pdfFileCache) {
    pdfFileCache = new LRUCache(3);
  }
  return pdfFileCache;
};
export const updateCdnUrlFromDotenv = (
  urlString: string,
  isEdge: boolean | undefined,
): string => {
  try {
    const CDN_BASE_URL = get_CDN_BASE_URL();
    if (CDN_BASE_URL) {
      let url = new URL(urlString);
      let cdnBaseUrl = new URL(CDN_BASE_URL);
      url.protocol = cdnBaseUrl.protocol;
      url.host = cdnBaseUrl.host;
      url.pathname = cdnBaseUrl.pathname + url.pathname;
      // remove duplicate environment segments (with or without slash between)
      url.pathname = url.pathname.replace(
        /\/production\/?production\//g,
        "/production/",
      );
      url.pathname = url.pathname.replace(
        /\/development\/?development\//g,
        "/development/",
      );
      // normalize any remaining consecutive slashes (e.g. from base "/" + "/development/...")
      url.pathname = url.pathname.replace(/\/\/+/g, "/");
      console.log(`url ${urlString} changing to ${url.toString()}`, {
        CDN_BASE_URL,
      });
      return url.toString();
    } else return urlString;
  } catch (error) {
    if (isEdge) {
      return get_CDN_BASE_URL() + urlString;
    }
    return urlString;
  }
};

export const removeMultipleSlashes = (url: string): string => {
  try {
    return url.replace(/([^:]\/)\/+/g, "$1");
  } catch (error) {
    return url;
  }
};

export const getSassToken = async (
  workspaceId: string,
  portalId: string,
  userId: string | null,
  jwtUserIdToken: string | null,
  isEdge?: boolean | null,
) => {
  if (isEdge === true) {
    const edgeUser = getEdgeUserLoginSession();

    // A portal token: it opens only the knowledge units published to this
    // portal, so the web-app cannot read the rest of the workspace.
    if (edgeUser?.user?.userIdToken) {
      return getEdgeSassToken(edgeUser.user.userIdToken, workspaceId, portalId);
    }

    // No login: this is a public portal visitor. Ask auth for an anonymous
    // session -- it decides whether the portal is actually public, and mints the
    // identity itself, so a visitor cannot name themselves.
    const anonSession = await getAnonPortalSession(workspaceId, portalId);
    if (anonSession) {
      return getEdgeSassToken(anonSession.token, workspaceId, portalId);
    }

    console.error("No edge session and no anonymous session available");
    return "";
  }
  try {
    const sasTokenResponse = await axios(
      `${get_AI_URI_BASE()}/cdn_uploader/workspace/${workspaceId}?userId=${userId}`,
      {
        headers: {
          Authorization: `Bearer ${jwtUserIdToken}`,
          "User-Id": userId,
          "Portal-Id": portalId,
        },
      },
    );
    if (sasTokenResponse?.data?.error) {
      console.error(
        `/error/${500}/errorMessage/${sasTokenResponse?.data?.error}`,
      );
      return "";
    } else if (sasTokenResponse?.data?.sasToken) {
      // all is ok, sas-token exist
      return sasTokenResponse?.data?.sasToken;
    } else {
      // sas-token not exist
      console.error(
        `/error/${500}/errorMessage/something wrong with sass-token`,
      );
      return "";
    }
  } catch (error) {
    // the AxiosError carries config.headers with the bearer token
    console.error(redactSecrets(error));
    return "";
  }
};

export interface AnonPortalSession {
  token: string;
  userId: string;
}

const anonSessionCacheKey = (workspaceId: string, portalId: string) =>
  `korra-anon-session:${workspaceId}:${portalId}`;

/**
 * Get (or start) the anonymous session for a public portal.
 *
 * This replaces a uuid the browser minted for itself. That uuid was not an
 * identity -- the client asserted it, so it could assert anyone's, which let a
 * visitor read another's saved items and get a document watermarked in their
 * name. Auth mints the id instead, checks server-side that the portal really is
 * public, and records the issue so a leaked document still traces back to a
 * visit.
 *
 * Held in localStorage, not sessionStorage: this token IS the visitor's
 * identity, so losing it loses their favourites. It replaces a cookie that was
 * set to a hundred years, and the token's own lifetime matches.
 */
export const getAnonPortalSession = async (
  workspaceId: string,
  portalId: string,
): Promise<AnonPortalSession | null> => {
  const cacheKey = anonSessionCacheKey(workspaceId, portalId);
  const cached = localStorage.getItem(cacheKey);
  if (cached) {
    try {
      const session = JSON.parse(cached) as {
        token: string;
        userId: string;
        expiresAt: number;
      };
      // Renew a little early so a token cannot expire mid-request.
      if (session.token && session.expiresAt * 1000 > Date.now() + 60_000) {
        return { token: session.token, userId: session.userId };
      }
    } catch {
      // Unreadable cache entry: fall through and start a fresh session.
    }
  }

  try {
    const response = await axios.post(
      `${get_AUTH_HOST()}/portal/anon-session`,
      { workspaceId, portalId },
    );
    const session = response?.data?.data;
    if (!session?.token || !session?.userId) {
      console.error("Anonymous session response was incomplete");
      return null;
    }
    localStorage.setItem(cacheKey, JSON.stringify(session));
    return { token: session.token, userId: session.userId };
  } catch (error) {
    // A 403 here is the normal answer for a portal that is not public.
    console.error("Could not start an anonymous portal session:", error);
    return null;
  }
};

/**
 * Mint a short-lived CDN token.
 *
 * The identity stamped into watermarks comes from the JWT, never from us. The
 * scope comes from workspaceId/portalId, but the server only honours them
 * against what the token says the caller may reach -- naming a workspace you are
 * not in is refused. Pass portalId to get a token limited to that portal's
 * knowledge units; omit it for a workspace-wide token.
 */
export const getEdgeSassToken = async (
  jwtToken: string | undefined,
  workspaceId: string,
  portalId?: string,
) => {
  // Without these the request can only fail, and it fails obscurely: the header
  // would read "Bearer undefined" and come back 401 as though the token were
  // rejected rather than absent. Say so here instead.
  if (!jwtToken || !workspaceId) {
    console.error(
      "Cannot mint a CDN token without both a session token and a workspace",
    );
    return "";
  }
  try {
    const sasTokenEdgeResponse = await axios.post(
      `${get_CDN_BASE_URL()}/generate-token`,
      { workspaceId, portalId },
      {
        headers: {
          Authorization: `Bearer ${jwtToken}`,
        },
      },
    );
    if (sasTokenEdgeResponse?.data?.error) {
      console.error(
        `/error/${500}/errorMessage/${sasTokenEdgeResponse?.data?.data?.error}`,
      );
      return "";
    } else if (sasTokenEdgeResponse?.data?.token) {
      // all is ok, sas-token exist
      return `sasToken=${sasTokenEdgeResponse?.data?.token}`;
    } else {
      // sas-token not exist
      console.error(
        `/error/${500}/errorMessage/something wrong with sass-token`,
      );
      return "";
    }
  } catch (error) {
    // the AxiosError carries config.headers with the bearer token
    console.error(redactSecrets(error));
    return "";
  }
};

/**
 * Stamp the CDN token onto a portal branding URL.
 *
 * On edge, a portal's logo and background are served token-free only while the
 * portal is public. A private portal's branding is refused without a token, and
 * an <img> tag cannot send an Authorization header, so the token rides in the
 * URL.
 *
 * The token is minted after the theme is seeded, so the URL is built first and
 * stamped when the token lands. The token is refreshed every few minutes, so a
 * URL already carrying one gets the old token swapped for the new one rather
 * than a second copy appended. Anything off edge is returned untouched.
 */
export const withCdnToken = (url: string, sasToken: string): string => {
  if (!url || !sasToken || !getIsEdge()) return url;
  const [base, query = ""] = url.split("?");
  const rest = query.split("&").filter((p) => p && !p.startsWith("sasToken="));
  return `${base}?${[...rest, sasToken].join("&")}`;
};

/**
 * Clear the flags a portal theme sets on the store.
 *
 * `setTheme` resets them on every portal resolution, but a bare kapp route
 * (`/workspace/:id/kapp/:id`) has no theme and never calls it, so moving there
 * from an RTL or year-range portal in one SPA session would otherwise keep the
 * previous portal's direction and panels. Keep in step with setTheme.
 */
export const resetPortalFlags = (dispatchFn: any) => {
  dispatchFn(setIsRTL(false));
  dispatchFn(setYearRangeEnabled(false));
  dispatchFn(setYearRangeEnabled2(false));
  resetChronologicalSort(dispatchFn);
};

/**
 * Chronological sort is a yearrange1-only control (the toggle lives in the
 * year-range bar), but its state is global search state and the results route
 * sorts by it on every portal. Clear it whenever a portal without that bar is
 * resolved, or a user who switched sort on a Bazan portal would keep getting
 * chronological results elsewhere with nothing to turn it off.
 */
const resetChronologicalSort = (dispatchFn: any) => {
  dispatchFn(setIsChronological(false));
  dispatchFn(setChronologicalOrder(false));
};

/**
 * set the theme
 * @param theme
 */
export const setTheme = (
  theme: Theme,
  dispatchFn: Function,
  workspaceId: string,
) => {
  try {
    if (theme) {
      if (theme.bgImage) {
        if (!get_IS_CDN77()) {
          let _bgImage = theme.bgImage;
          if (_bgImage.startsWith(workspaceId)) {
            _bgImage = _bgImage.replace(workspaceId, "");
          }
          dispatchFn(
            setBackgroundImage(
              `${get_CDN_BASE_URL()}/public/${workspaceId}${encodeURIComponent(
                _bgImage,
              )}`
                .replace(
                  "https://prod-storage-eue5bvbhcbe5ageh.z02.azurefd.net/",
                  "https://cdn.korra.ai/",
                )
                .replace(
                  "https://cdn.korra.ai/production/public/",
                  "https://cdn.korra.ai/public/",
                ),
            ),
          );
        } else {
          dispatchFn(
            setBackgroundImage(
              `${get_CDN_BASE_URL()}/${get_CDN_ROOT_FOLDER()}/${encodeURIComponent(
                theme.bgImage,
              )}`,
            ),
          );
        }
      }
      if (theme.bgPortraitImage) {
        if (!get_IS_CDN77()) {
          let _bgPortraitImage = theme.bgPortraitImage;
          if (_bgPortraitImage.startsWith(workspaceId)) {
            _bgPortraitImage = _bgPortraitImage.replace(workspaceId, "");
          }
          dispatchFn(
            setBgPortraitImage(
              `${get_CDN_BASE_URL()}/public/${workspaceId}${encodeURIComponent(
                _bgPortraitImage,
              )}`
                .replace(
                  "https://prod-storage-eue5bvbhcbe5ageh.z02.azurefd.net/",
                  "https://cdn.korra.ai/",
                )
                .replace(
                  "https://cdn.korra.ai/production/public/",
                  "https://cdn.korra.ai/public/",
                ),
            ),
          );
        } else {
          dispatchFn(
            setBgPortraitImage(
              `${get_CDN_BASE_URL()}/${get_CDN_ROOT_FOLDER()}/${encodeURIComponent(
                theme.bgPortraitImage,
              )}`,
            ),
          );
        }
      }

      if (theme.imageLayout) {
        dispatchFn(setBackgroundSize(`${theme.imageLayout}`));
      }
      if (theme.logoImage) {
        if (!get_IS_CDN77()) {
          let _logoImage = theme.logoImage;
          if (_logoImage.startsWith(workspaceId)) {
            _logoImage = _logoImage.replace(workspaceId, "");
          }
          dispatchFn(
            setLogoSrc(
              `${get_CDN_BASE_URL()}/public/${workspaceId}${encodeURIComponent(
                _logoImage,
              )}`
                .replace(
                  "https://prod-storage-eue5bvbhcbe5ageh.z02.azurefd.net/",
                  "https://cdn.korra.ai/",
                )
                .replace(
                  "https://cdn.korra.ai/production/public/",
                  "https://cdn.korra.ai/public/",
                ),
            ),
          );
        } else {
          dispatchFn(
            setLogoSrc(
              `${get_CDN_BASE_URL()}/${get_CDN_ROOT_FOLDER()}/${encodeURIComponent(theme.logoImage)}`,
            ),
          );
        }
      }

      if (theme.logoUrl)
        dispatchFn(
          setLogoHref(
            `${
              theme.logoUrl.startsWith("http")
                ? theme.logoUrl
                : `https://${theme.logoUrl}`
            }`,
          ),
        );
      if (theme.questionsForExample)
        dispatchFn(setQuestionsForExample(theme.questionsForExample));
      if (theme.contactUsDestinationLink)
        dispatchFn(setContactUsDestinationLink(theme.contactUsDestinationLink));
      dispatchFn(
        setContactUsDestinationMessage(theme.contactUsDestinationMessage),
      );
      if (theme.fileRepositoryDestinationLink)
        dispatchFn(
          setFileRepositoryDestinationLink(theme.fileRepositoryDestinationLink),
        );
      dispatchFn(
        setEnableContactUsDestinationLink(
          !!theme.enableContactUsDestinationLink,
        ),
      );
      dispatchFn(
        setEnableFileRepositoryDestinationLink(
          !!theme.enableFileRepositoryDestinationLink,
        ),
      );
      dispatchFn(
        setEnableQuestionsForExample(!!theme.enableQuestionsForExample),
      );
      if (theme.searchBarPlaceHolder)
        dispatchFn(setSearchBarPlaceHolder(theme.searchBarPlaceHolder));
      dispatchFn(setDisableFilters(!!theme.disableFilters));

      dispatchFn(setFiltersType(theme.filtersType));
      dispatchFn(setShowFilePath(theme.showFilePath));
      dispatchFn(setTagMessageMap(theme.tagMessageMap || {}));
      dispatchFn(setFilterSidebarTagsFirst(!!theme.filterSidebarTagsFirst));
      dispatchFn(setShowHomePageFilter(theme.showHomePageFilter));
      dispatchFn(
        setMediaTypeClientSideFiltering(theme.mediaTypeClientSideFiltering),
      );
      dispatchFn(setShowKeywordFilterFlag(theme.showKeywordFilter));
      dispatchFn(setIsPrivate(!!theme.isPrivate));
      dispatchFn(setHighlightPdf(!!theme.highlightPdf));
      dispatchFn(setHideFileName(!!theme.hideFileName));
      dispatchFn(setShowManyHeaders(!!theme.showManyHeaders));
      dispatchFn(setShowRelatedDocuments(theme.showRelatedDocuments));
      dispatchFn(setExplanator(theme.explanator));
      dispatchFn(setEnableKeywordToggle(theme.enableKeywordToggle));
      dispatchFn(setDisableRag(!!theme.disableRag));
      // The workspace watermark setting (#1043), filled into the theme by the
      // app service; a portal has no watermark setting of its own.
      dispatchFn(setDocumentWatermark(!!theme.documentWatermark));
      dispatchFn(setCompactSearchArea(!!theme.compactSearchArea));
      dispatchFn(setActiveLogger(!!theme.activeLogger));
      // Honor the per-portal toggle on all environments. Themes that predate
      // this flag (undefined) fall back to the environment default: enabled in
      // cloud, disabled on edge (issue #1106).
      dispatchFn(setEnableImageSearch(theme.enableImageSearch ?? !getIsEdge()));
      dispatchFn(setExpandGptAnswer(!!theme.expandGptAnswer));
      dispatchFn(setUseGptPolling(!!theme.useGptPolling));

      (global as any)._loggerEnabled = !!theme.activeLogger;

      if (theme.max_per_subject)
        dispatchFn(setMaxPerSubject(theme.max_per_subject));
      dispatchFn(setLoaded(true));

      // Dispatched unconditionally: setTheme runs again on every portal
      // resolution, so a guarded dispatch leaves the previous portal's flag
      // latched on when switching portals within one SPA session (no reload).
      // A route with no theme at all goes through resetPortalFlags instead.
      dispatchFn(setIsRTL(!!theme.rtlenabled));

      const specialFeatures = theme.specialFeatures?.toLowerCase();
      dispatchFn(setYearRangeEnabled(specialFeatures === "yearrange1"));
      dispatchFn(setYearRangeEnabled2(specialFeatures === "yearrange2"));
      if (specialFeatures !== "yearrange1") resetChronologicalSort(dispatchFn);

      // Feature toggles (filters default enabled, favorites/recently-viewed default disabled)
      dispatchFn(
        setEnableFilters(
          theme.enableFilters !== undefined ? theme.enableFilters : true,
        ),
      );
      dispatchFn(
        setEnableFavorites(
          theme.enableFavorites !== undefined ? theme.enableFavorites : false,
        ),
      );
      dispatchFn(
        setEnableRecentlyViewed(
          theme.enableRecentlyViewed !== undefined
            ? theme.enableRecentlyViewed
            : false,
        ),
      );
      // Dive Deeper defaults to on; themes that predate the toggle (undefined)
      // keep the feature (issue #1640).
      dispatchFn(
        setEnableDiveDeeper(
          theme.enableDiveDeeper !== undefined ? theme.enableDiveDeeper : true,
        ),
      );
    }
  } catch (error) {
    dispatchFn(setLoaded(false));
    // the AxiosError carries config.headers with the bearer token
    console.error(redactSecrets(error));
  }
};

// chronologicalOrder = true => descending order
export const sortSearchResultsChronologically = (
  searchResults: any[],
  chronologicalOrder: boolean,
): any[] => {
  return searchResults.sort((a: any, b: any) => {
    const aYear = a?.search?.tags?.find(
      (tag: string) => tag?.length == 4 && !isNaN(Number(tag)),
    );
    const bYear = b?.search?.tags?.find(
      (tag: string) => tag?.length == 4 && !isNaN(Number(tag)),
    );
    if (aYear && bYear) {
      if (chronologicalOrder) {
        return Number(aYear) - Number(bYear);
      } else {
        return Number(bYear) - Number(aYear);
      }
    }
    return 0;
  });
};

// Fetches the portal's document libraries (kapp -> documents, incl. tags) from
// the dashboard service. This feeds the bazan home filter panel's allDocuments.
export const getArticlesForExample = async (
  workspaceId: string,
  portalId: string,
  mode: string,
  userId: string | null,
  token: string | null,
): Promise<Library[]> => {
  try {
    const response = await axios(
      `${get_DASHBOARD_URI_BASE()}/libraries/web-app/all/workspace/${workspaceId}/portal/${portalId}/mode/${mode}?userId=${userId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "User-Id": userId,
          "Portal-Id": portalId,
        },
      },
    );
    if (response?.data?.data && response?.data?.data?.length > 0) {
      return response.data.data as Library[];
    }
    return [];
  } catch (error) {
    // the AxiosError carries config.headers with the bearer token
    console.error(redactSecrets(error));
    return [];
  }
};

export const getFirstGuidByDocGuid = async (
  workspaceId: string,
  portalId: string,
  kappId: string,
  docGuid: string,
  userId: string | null,
  token: string | null,
): Promise<GetFirstGuidResponse | null> => {
  try {
    const response = await axios(
      `${get_DASHBOARD_URI_BASE()}/libraries/web-app/first-guid/workspace/${workspaceId}/kapp/${kappId}/docs/${docGuid}?userId=${userId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "User-Id": userId,
          "Portal-Id": portalId,
        },
      },
    );
    if (response?.data?.data && response?.data?.data?.guid) {
      return response.data.data as GetFirstGuidResponse;
    } else {
      console.error("No libraries found, or error in the response");
      return null;
    }
  } catch (error) {
    // the AxiosError carries config.headers with the bearer token
    console.error(redactSecrets(error));
    return null;
  }
};

export const startSession = async (
  workspaceId: string,
  portalId: string,
  userId: string | null,
  token: string | null,
  newChat: boolean,
  ip?: string,
): Promise<StartSessionResponse> => {
  const url = new URL(`${get_AI_URI_BASE()}/session_manager/start`);

  // One-shot: forward the Mosaic login correlation id (set by the router on the
  // login redirect) on the first successful start only, then clear it so later
  // sessions aren't mis-attributed to the same login. It is cleared only once a
  // start succeeds: appLogic retries a failed start, and the retry must still
  // carry it or the login can't be joined to its session.
  let loginId = "";
  try {
    // Tab-scoped (sessionStorage): only the tab that received the Mosaic redirect
    // holds the id, so a concurrent tab's startSession can't consume it first.
    loginId = sessionStorage.getItem("Web-app-mosaicLoginId") ?? "";
  } catch (e) {
    loginId = "";
  }

  const reqObj = {
    workspaceId,
    portalId,
    userId,
    newChat,
    ...(loginId ? { loginId } : {}),
  };

  const res = await fetch(<any>url.toString(), {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token as string}`,
      "User-Id": userId as string,
      "Portal-Id": portalId as string,
    },
    method: "POST",
    body: JSON.stringify(reqObj),
    mode: "cors",
  });

  const userResp: IResponse<StartSessionResponse> = await res.json();

  if (userResp.error) {
    throw new Error(userResp.error.message);
  }
  if (loginId && userResp.data?.sessionId) {
    try {
      sessionStorage.removeItem("Web-app-mosaicLoginId");
    } catch (e) {
      // ignore storage failures
    }
  }
  return userResp.data;
};

/**
 * The effective user id for session and analytics calls (issue #1733).
 *
 * On edge the login email comes first: edge stats rows and sessions have always
 * been keyed by it, and edge login now also sets `globals.userId` (to the user's
 * id), which would otherwise silently switch keying and split one visitor into
 * an email-keyed and an id-keyed session. Then `globals.userId` (a public-portal
 * visitor's anonymous id), then the edge user's id. In cloud it is
 * `globals.userId`. Single source of truth for `sendEvent`, `appLogic` and
 * `endCurrentSession`, so the rule can't drift.
 */
export const getEffectiveUserId = (): string => {
  const g = store.getState().globals;
  if (getIsEdge()) {
    const edge = getEdgeUserLoginSession();
    return edge?.user?.email || g.userId || edge?.user?.id || "";
  }
  return g.userId || "";
};

/** Companion to {@link getEffectiveUserId} for the workspace token. */
export const getEffectiveToken = (): string | null => {
  const g = store.getState().globals;
  if (g.jwtUserIdToken) return g.jwtUserIdToken;
  if (getIsEdge()) {
    const edge = getEdgeUserLoginSession();
    return edge?.user?.userIdToken || null;
  }
  return null;
};

// --- Open-tab tracking for multi-tab-safe session end (issue #1733) ---------
// Sessions are keyed by (userId, portalId), so several tabs open on the same
// user/portal share one sessionId. The automatic pagehide end must therefore
// only fire when the closing tab is the last one open, or it would end the
// session out from under the still-open tabs. Each page load owns one
// localStorage key for that scope, holding when it last checked in.
//
// One key per page, not one shared set: registering and unregistering are then
// a single setItem/removeItem, and no page ever rewrites another's entry.
// With a shared set, two tabs updating at once could each read it, add their
// own id and overwrite the other's write; there is no cross-tab lock to
// prevent that (Firefox 67 has no Web Locks API).
//
// The id lives in module state, so it is new on every page load. Kept in
// sessionStorage it would be cloned by a browser "Duplicate tab", and two
// pages sharing one entry would each look like the last tab when closed. A
// refresh does not need to keep it: the old page's pagehide removes its entry
// and the reloaded page registers its own.

// How often an open tab refreshes its entry (appLogic runs the timer).
export const OPEN_TAB_REFRESH_MS = 60 * 1000;
// An entry not refreshed for this long is dropped: its tab crashed or was
// frozen, never ran its pagehide, and would otherwise hold the scope open and
// suppress the end. Matches the server's idle limit — a session with no ping
// for this long is ended by session_manager anyway.
const OPEN_TABS_STALE_MS = 30 * 60 * 1000;

const PAGE_TAB_ID =
  typeof crypto !== "undefined" && crypto.randomUUID
    ? crypto.randomUUID()
    : `${Date.now().toString(36)}-${Math.random().toString(36).slice(2)}`;

const openTabPrefix = (ws?: string, pt?: string, uid?: string | null): string =>
  `Web-app-openTab::${ws || ""}::${pt || ""}::${uid || ""}::`;

/**
 * How many other tabs are open on this scope. Entries that stopped refreshing
 * (or don't hold a time) are removed on the way, as their tabs are gone.
 */
const countOtherOpenTabs = (prefix: string, ownKey: string): number => {
  const cutoff = Date.now() - OPEN_TABS_STALE_MS;
  const stale: string[] = [];
  let open = 0;
  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i);
    if (!key || key === ownKey || !key.startsWith(prefix)) continue;
    if (Number(localStorage.getItem(key)) >= cutoff) open += 1;
    else stale.push(key);
  }
  stale.forEach((key) => localStorage.removeItem(key));
  return open;
};

/**
 * Record (or refresh) this tab as sharing the (workspace, portal, user) session.
 * Call it again on a timer so a long-lived tab isn't pruned as stale.
 */
export const registerOpenTab = (
  ws?: string,
  pt?: string,
  uid?: string | null,
): void => {
  try {
    localStorage.setItem(
      openTabPrefix(ws, pt, uid) + PAGE_TAB_ID,
      String(Date.now()),
    );
  } catch {
    // best effort — tab tracking must never break the app
  }
};

/**
 * Remove this tab's entry; returns true when it was the last open tab, so the
 * caller should end the session. A storage failure is treated as "last tab" so
 * a broken store still ends the session rather than leaking it.
 */
export const unregisterOpenTab = (
  ws?: string,
  pt?: string,
  uid?: string | null,
): boolean => {
  try {
    const prefix = openTabPrefix(ws, pt, uid);
    const ownKey = prefix + PAGE_TAB_ID;
    localStorage.removeItem(ownKey);
    return countOtherOpenTabs(prefix, ownKey) === 0;
  } catch {
    return true;
  }
};

/**
 * End the current session (issue #1733). Fired on tab/window close and on
 * logout, so session_manager emits an EndSession carrying the same sessionId as
 * the session's other events, letting a session be reconstructed end-to-end and
 * its duration computed.
 *
 * A tab-close end is held server-side for a short grace window, because a
 * refresh or a same-tab navigation fires the same pagehide and its start/ping
 * must be able to continue the session. `immediate` skips that window; logout
 * sets it, or logging back in as the same user within the window would continue
 * the old session.
 *
 * Delivery uses navigator.sendBeacon, the only reliable transport during unload
 * (a normal fetch/XHR is cancelled). The body is sent as text/plain so the
 * request stays CORS-simple (no preflight, which the browser drops on unload);
 * the /session_manager/end endpoint parses the raw JSON body accordingly.
 */
export const endSession = (
  workspaceId: string,
  portalId: string,
  userId: string | null,
  sessionId: string | null,
  immediate = false,
): boolean => {
  try {
    if (!sessionId) return false;
    const url = `${get_AI_URI_BASE()}/session_manager/end`;
    const body = JSON.stringify({
      workspaceId,
      portalId,
      userId,
      sessionId,
      immediate,
    });
    if (typeof navigator !== "undefined" && navigator.sendBeacon) {
      const blob = new Blob([body], { type: "text/plain;charset=UTF-8" });
      // false means the browser did not queue it (its beacon quota is full,
      // for one): fall through to the fetch rather than lose the end.
      if (navigator.sendBeacon(url, blob)) return true;
    }
    // Fallback for a browser without sendBeacon, or one that refused it: a
    // keepalive fetch still has a chance of completing during unload.
    fetch(<any>url, {
      method: "POST",
      body,
      keepalive: true,
      headers: { "Content-Type": "text/plain" },
      mode: "cors",
    }).catch(() => {});
    return true;
  } catch {
    return false;
  }
};

/**
 * End the session tracked in redux, immediately. Used by the SPA logout paths,
 * which route client-side and so never fire `pagehide`, and which must not
 * leave the session inside the tab-close grace window.
 */
export const endCurrentSession = (): void => {
  try {
    const state = store.getState();
    const sessionId = state.globals.sessionId;
    if (!sessionId) return;
    endSession(
      state.alias.workspaceId,
      state.alias.portalId,
      getEffectiveUserId(),
      sessionId,
      true,
    );
  } catch {
    // best effort — never block logout on analytics
  }
};

export const PingSession = async (
  workspaceId: string,
  portalId: string,
  sessionId: string | null,
  userId: string | null,
  token: string | null,
  newChat: boolean,
  ip?: string,
): Promise<PingSessionResponse | null> => {
  try {
    const url = new URL(`${get_AI_URI_BASE()}/session_manager/ping`);
    const reqObj = {
      workspaceId,
      portalId,
      userId,
      newChat,
    };

    const response = await fetch(<any>url.toString(), {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token as string}`,
        "User-Id": userId as string,
        "Portal-Id": portalId as string,
      },
      method: "POST",
      body: JSON.stringify(reqObj),
      mode: "cors",
    });

    const userResp: IResponse<PingSessionResponse> = await response.json();

    if (userResp.error) {
      throw new Error(userResp.error.message);
    } else {
      return userResp.data;
    }
  } catch (error) {
    // the AxiosError carries config.headers with the bearer token
    console.error(redactSecrets(error));
    return null;
  }
};

export function hashCode(str: string) {
  return Array.from(str)
    .reduce((s, c) => (Math.imul(31, s) + c.charCodeAt(0)) | 0, 0)
    .toString();
}

export const getPortal = async (
  workspaceId: string,
  portalId: string,
  userId: string | null,
  token: string | null,
  dispatch: any,
): Promise<PortalItem> => {
  const url = `${get_DASHBOARD_URI_BASE()}/portals/${portalId}/workspaces/${workspaceId}?userId=${userId}`;
  const res = await fetch(<any>url, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    method: "GET",
    mode: "cors",
  });

  const portal: IResponse<PortalItem> = await res.json();
  if (portal.error) {
    dispatch(setLoading(false));
    throw new Error(portal.error.message);
  } else {
    dispatch(setLoading(true));
    return portal.data;
  }
};

export const toKorraDateFormat = (date: Date): string => {
  const day = date.getDate().toString().padStart(2, "0");
  const month = date.toLocaleDateString("en-US", { month: "short" });
  const year = date.getFullYear().toString().slice(-2); // Last two digits of the year
  return `${day}-${month}-${year}`;
};

export const saveEdgeUserLoginSession = (
  user: EdgeUser,
  selectedPage: string,
  workspaceAlias?: string,
): void => {
  const storageObject = {
    user,
    workspaceId: selectedPage,
    workspaceAlias,
    timestamp: Date.now(), // Current time in milliseconds
  };
  localStorage.setItem("Web-app-edgeUser", JSON.stringify(storageObject));
  // Login lands in place, with no reload, and may be a different user than the
  // last one. The token key cannot tell edge users apart (their id is not in
  // globals), so re-mint for this user: local_cdn watermarks by the token's user.
  // The generation tells components that keep a token (sticky, video src).
  userSessions.generation += 1;
  void queryClient.resetQueries({ queryKey: ["sasToken"] });
};

export const getEdgeUserLoginSession = (): StoredEdgeUser | null => {
  const stored = localStorage.getItem("Web-app-edgeUser");
  if (stored) {
    try {
      return JSON.parse(stored) as StoredEdgeUser;
    } catch (error) {
      console.error("Error parsing stored user data:", error);
    }
  }
  return null;
};

// The stored session's `workspaceId` actually holds the portal alias the user
// landed on, and the router redirects to login when it disagrees with the
// current route (portal alias and, if present, workspace alias). Switching
// workspaces must therefore move both along with the route; the timestamp is
// preserved so switching doesn't extend the session.
export const UpdateEdgeUserSessionPortalAlias = (
  portalAlias: string,
  workspaceAlias?: string,
): void => {
  const stored = localStorage.getItem("Web-app-edgeUser");
  if (stored) {
    try {
      const user = JSON.parse(stored) as StoredEdgeUser;
      user.workspaceId = portalAlias;
      if (workspaceAlias !== undefined) user.workspaceAlias = workspaceAlias;
      localStorage.setItem("Web-app-edgeUser", JSON.stringify(user));
    } catch (error) {
      console.error("Error Updating stored user portal alias:", error);
    }
  }
};

// Load-time gate for an edge session (issue #1100): whether a stored login is
// worth hydrating on load. The window depends on the token. A session-backed
// token (session_id claim) gets the ABSOLUTE 12h lifetime from login: the
// SessionManager and the server enforce idle, expiry and revocation while the app
// runs. Any other token (Mosaic, legacy) is not managed by anything, so it keeps
// the previous 1h window — a 12h window would reopen a stale Mosaic login with an
// expired token, or keep a 7-day token signed in for 12h.
export const EDGE_UNMANAGED_SESSION_MAX_AGE_MS = 60 * 60 * 1000;

export const isEdgeUserSessionExpired = (
  timestamp: number,
  token?: string | null,
): boolean => {
  const maxAgeMs = decodeEdgeSessionClaims(token).sessionId
    ? SESSION_POLICY.ABSOLUTE_MS
    : EDGE_UNMANAGED_SESSION_MAX_AGE_MS;
  return Date.now() - timestamp > maxAgeMs;
};

export const encorderQuestion = (question: string): string => {
  const resp = encodeURIComponent(question);
  return resp;
};

// ID generators for favorites / recently-viewed items.
// (Persistence + API sync now live in src/api/userdata.ts + the React Query
// hooks; localStorage caching is handled automatically by the persisted
// QueryClient — see src/lib/queryClient.ts.)
export const generateFavoriteId = (): string => {
  return `fav_${Date.now()}_${Math.random().toString(36).slice(2, 11)}`;
};

export const generateRecentlyViewedId = (): string => {
  return `rv_${Date.now()}_${Math.random().toString(36).slice(2, 11)}`;
};

// Userdata + filter-state API calls now live in src/api/userdata.ts (consumed
// by the React Query hooks in src/hooks).

export const copyTextToClipboard = async (text: string): Promise<void> => {
  if (navigator.clipboard?.writeText) {
    try {
      await navigator.clipboard.writeText(text);
      return;
    } catch {
      // fall through to legacy fallback (e.g. non-secure HTTP context)
    }
  }
  const ta = document.createElement("textarea");
  ta.value = text;
  ta.setAttribute("data-allow-copy", "");
  ta.style.position = "fixed";
  ta.style.opacity = "0";
  document.body.appendChild(ta);
  ta.select();
  try {
    document.execCommand("copy");
  } finally {
    document.body.removeChild(ta);
  }
};

// Cleans a search-result snippet for display, stripping special tags that are
// meaningless to end users. For images we return nothing (the machine-generated
// description is hidden - issue #1571); for tables we turn cell/row tags into
// readable comma/newline separators.
export const cleanSnippet = (
  text: string,
  opts?: { isImage?: boolean },
): string => {
  if (!text) return "";

  // Image results: hide the machine-generated description text below the thumbnail (issue #1571).
  if (opts?.isImage) return "";

  // Table branch: cell/row tags carry structure, so map them to readable
  // separators instead of blank-deleting (which collapses cells together).
  if (/<table/i.test(text)) {
    return (
      text
        // End of a cell -> comma separator between cell values.
        .replace(/<\/(td|th)>/gi, ", ")
        // End of a row -> newline separator between rows.
        .replace(/<\/tr>/gi, "\n")
        // Drop every remaining tag (opening td/th/tr, table, tbody, etc.).
        .replace(/<[^>]*>/g, "")
        // Collapse repeated separators and stray whitespace. Use [ \t] rather
        // than \s so the \n row separators added above are preserved.
        .replace(/(,[ \t]*)+/g, ", ")
        .replace(/[ \t]+/g, " ")
        // Remove leading/trailing commas around each line.
        .replace(/^[\s,]+|[\s,]+$/gm, "")
        .trim()
    );
  }

  // Default: strip any residual tags.
  return text.replace(/<\/?[^>]+(>|$)/g, "").trim();
};
